import { Component } from '@angular/core';
import {IMerchant} from './IMerchant';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'pm-merchant-list',
  templateUrl: './merchant-list.component.html',
  styleUrls: ['./merchant-list.component.sass']
})
export class MerchantListComponent {
  public showComercios = true;
  public showAddComercios = false;
  public showEditComercios = false;
  public showModalComercios = false;
  public showSearchMerchant = false;
  public editnumber = 0;
  public resultadosBusqueda: IMerchant[] = [];
  public showEditRolComercios = false;

}
